export { default } from './QrHeader';



// WEBPACK FOOTER //
// ./src/components/organisms/QrHeader/index.js